export default __webpack_public_path__ + "static/media/12_photo.9ecd2de7.jpg";